// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pot-header-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.pot-header-title {
  margin: 0;
}
.pot-edit-btn-no-bg {
  background: none;
  border: none;
  padding: 0;
}
.irrigation-custom-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 4px;
}
.plant-add-btn-container {
  margin-left: 2%;
}
.hidden-opacity {
  opacity: 0;
  pointer-events: auto;
}
.status-row-title {
  font-size: 18px;
  font-weight: bold;
}
.irrigating {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}


.not-irrigating {
  opacity: 1;
  cursor: pointer;
}

.level-box {
  width: 30px;
  height: 30px;
  display: inline-flex;          /* keep it inline with text */
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}
.level-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;           /* keep aspect ratio */
}
.level-text {
  margin-left: 8px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/PotManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;;AAGA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB,WAAW,6BAA6B;EAC5D,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,YAAY,sBAAsB;AACvD;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".pot-header-flex {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.pot-header-title {\n  margin: 0;\n}\n.pot-edit-btn-no-bg {\n  background: none;\n  border: none;\n  padding: 0;\n}\n.irrigation-custom-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 4px;\n}\n.plant-add-btn-container {\n  margin-left: 2%;\n}\n.hidden-opacity {\n  opacity: 0;\n  pointer-events: auto;\n}\n.status-row-title {\n  font-size: 18px;\n  font-weight: bold;\n}\n.irrigating {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n\n.not-irrigating {\n  opacity: 1;\n  cursor: pointer;\n}\n\n.level-box {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;          /* keep it inline with text */\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n}\n.level-box img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;           /* keep aspect ratio */\n}\n.level-text {\n  margin-left: 8px;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
